import { render, staticRenderFns } from "./JCodeEditor2.vue?vue&type=template&id=58930eb4"
import script from "./JCodeEditor2.vue?vue&type=script&lang=js"
export * from "./JCodeEditor2.vue?vue&type=script&lang=js"
import style0 from "./JCodeEditor2.vue?vue&type=style&index=0&id=58930eb4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports